import logger from './utils/logger';

// Service Worker Registration
// Guards against re-prompting/reloading more than once per page session — the
// old code could loop the "New version available" confirm indefinitely.
let updatePromptShown = false;

export function register() {
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      const swUrl = '/service-worker.js';

      navigator.serviceWorker
        .register(swUrl)
        .then((registration) => {
          registration.onupdatefound = () => {
            const installingWorker = registration.installing;
            if (installingWorker == null) {
              return;
            }
            installingWorker.onstatechange = () => {
              if (installingWorker.state === 'installed') {
                if (navigator.serviceWorker.controller) {
                  // Notify app via custom event rather than blocking modal confirm
                  if (!updatePromptShown) {
                    updatePromptShown = true;
                    window.dispatchEvent(new CustomEvent('synexos:sw-update-available'));
                  }
                }
              }
            };
          };
        })
        .catch((error) => {
          logger.error(
            "Service worker registration failed:",
            error?.message || "Service worker registration error"
          );
        });
    });
  } else if (process.env.NODE_ENV === 'development' && 'serviceWorker' in navigator) {
    // In development mode, unregister any active service workers on localhost to prevent stale chunk caching during rebuilds
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch(() => {});
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        logger.error(
          "Service worker unregistration failed:",
          error?.message || "Service worker unregistration error"
        );
      });
  }
}

// Request notification permission
export async function requestNotificationPermission() {
  if ('Notification' in window) {
    const permission = await Notification.requestPermission();
    return permission === 'granted';
  }
  return false;
}

// Check if app is installed as PWA
export function isPWA() {
  return window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true;
}

// Show install prompt
let deferredPrompt = null;

window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  deferredPrompt = e;
});

export async function showInstallPrompt() {
  if (deferredPrompt) {
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    deferredPrompt = null;
    return outcome === 'accepted';
  }
  return false;
}

export function canInstall() {
  return deferredPrompt !== null;
}
